import { Component, OnInit } from '@angular/core';
import { FlashMessagesService } from "angular2-flash-messages";
import { Router } from '@angular/router';
import { MatDialog } from "@angular/material";
import { CommonService } from "../../_services/common.service";
import { PurchaseOrderService } from '../../_services/purchase-order.service';
import { VendorService } from '../../_services/vendor.service';
import { VendorFormComponent } from '../vendor-form/vendor-form.component';

@Component({
  selector: 'app-purchase-order-list',
  templateUrl: './purchase-order-list.component.html',
  styleUrls: ['./purchase-order-list.component.css']
})
export class PurchaseOrderListComponent implements OnInit {
  loading = false;
  orderList: Array<any> = [];
  vendorList: Array<any> = [];
  ssactivewearTotalPrice = 0;
  sanmarTotalPrice = 0;
  alphabroderTotalPrice = 0;

  constructor(private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService,
    private router: Router,
    private purchaseOrderService: PurchaseOrderService,
    private vendorService: VendorService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.getPOList();
  }

  getPOList() {
    this.loading = true;
    this.purchaseOrderService.getPendingOrders().subscribe({
      next: (data) => {
        this.orderList = data;
        this.calculateTotals(this.orderList);
        this.getVendorList();
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load purchase orders', err);
        this.loading = false;
      }
    });
  }

  calculateTotals(orderList) {
    this.ssactivewearTotalPrice = 0;
    this.sanmarTotalPrice = 0;
    this.alphabroderTotalPrice = 0;

    if (orderList && orderList.length > 0) {
      orderList.forEach(item => {
        if (item.catalog === 'ssactivewear') {
          this.ssactivewearTotalPrice += (item.price || 0) * (item.quantity || 0);
        }
        if (item.catalog === 'sanmar') {
          this.sanmarTotalPrice += (item.price || 0) * (item.quantity || 0);
        }
        if (item.catalog === 'alphabroder') {
          this.alphabroderTotalPrice += (item.price || 0) * (item.quantity || 0);
        }
      });
    }
  }

  clickToGo(pathUrl){
    if(pathUrl == 'invoices' || pathUrl == 'dashboard'){
      this.loading = true;
      this.router.navigate([pathUrl]);
    }
  }

  redirectToGo(pathUrl){
    if(pathUrl == 'po/vendors'){
      this.loading = true;
      this.router.navigate([pathUrl]);
    }
  }

  onPrint() {
    window.print();
  }

  getVendorList() {
    this.vendorService.getList({}).subscribe({
      next: (res) => {
        if (res.status && res.data) {
          this.vendorList = res.data.records;
        }
      },
      error: (err) => {
      }
    });
  }

  openVendorDialog(vendor: any): void {
    const dialogRef = this.dialog.open(VendorFormComponent, {
      width: '600px',
      data: { vendor: vendor || null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.status) {
        this.getVendorList();
      }
    });
  }

  sendPO(poData) {
    if (!poData.vendor_id) {
      this._flashMessagesService.show('Please select a vendor before sending the PO.', {
        cssClass: 'alert-danger', 
        timeout: 3000
      });
      return;
    }
    
    this.loading = true;
    this.purchaseOrderService.sendPOItems(poData).subscribe({
      next: (result) => {
        this.loading = false;
        if (result && result.status) {
          this._flashMessagesService.show(result.message, {
            cssClass: 'alert-success', 
            timeout: 3000
          });

          this.getPOList();
        }
      },
      error: (err) => {
        this.loading = false;
      }
    });
  }

  markOrdered(poData) {
    if (!poData.purchase_order_id) {
      this._flashMessagesService.show('Please select a vendor and send the PO first, then you can mark it as ordered.', {
        cssClass: 'alert-danger', 
        timeout: 3000
      });
      return;
    }
    
    this.loading = true;
    const data = {
      vendor_id: poData.vendor_id,
      purchase_order_id: poData.purchase_order_id,
    };
    this.purchaseOrderService.markAsOrdered(data).subscribe({
      next: (result) => {
        this.loading = false;
        if (result && result.status) {
          this._flashMessagesService.show(result.message, {
            cssClass: 'alert-success', 
            timeout: 3000
          });

          this.getPOList();
        }
      },
      error: (err) => {
        this.loading = false;
      }
    });
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/purchase-order-list/purchase-order-list.component.ts